module.exports = __webpack_public_path__ + "img/20210906-1630910887398696.401bc7a0.jpg";